"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Modal = _interopRequireDefault(require("react-bootstrap/Modal"));
var _Button = _interopRequireDefault(require("react-bootstrap/Button"));
var _Form = _interopRequireDefault(require("react-bootstrap/Form"));
var _Collapse = _interopRequireDefault(require("react-bootstrap/Collapse"));
var _Spinner = _interopRequireDefault(require("react-bootstrap/Spinner"));
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
var _AnalyticsWrapper = _interopRequireDefault(require("../AnalyticsWrapper"));
var _cookieSettings = _interopRequireDefault(require("../cookie-settings.json"));
require("./index.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const CookieSettings = _ref => {
  let {
    privacyPolicyLink,
    configUrl,
    analytics,
    pathSpecific = true
  } = _ref;
  const [showModal, setShowModal] = (0, _react.useState)(false);
  const [loading, setLoading] = (0, _react.useState)(false);
  const [hasConsented, setHasConsented] = (0, _react.useState)(false);
  const [expandedSection, setExpandedSection] = (0, _react.useState)(null);
  const [config, setConfig] = (0, _react.useState)(null);
  const [preferences, setPreferences] = (0, _react.useState)({
    targeting: true,
    socialMedia: true,
    functional: true,
    performance: true,
    necessary: true
  });

  // Get current full URL for URL-specific storage
  const getCurrentUrl = () => {
    return pathSpecific ? window.location.href : '';
  };

  // Helper functions to save and load from localStorage with URL-specific keys
  const getStorageKey = baseKey => {
    const urlSuffix = getCurrentUrl();

    // Replace special characters with hyphens instead of encoding
    let simplifiedSuffix = '';
    if (urlSuffix) {
      // Remove protocol (http:// or https://)
      let cleanUrl = urlSuffix.replace(/^https?:\/\//, '');

      // Replace all special characters (including periods) with a single hyphen
      cleanUrl = cleanUrl.replace(/[^a-zA-Z0-9]/g, '-');

      // Replace multiple consecutive hyphens with a single one
      cleanUrl = cleanUrl.replace(/-+/g, '-');

      // Remove leading or trailing hyphens
      cleanUrl = cleanUrl.replace(/^-|-$/g, '');
      simplifiedSuffix = cleanUrl ? "-".concat(cleanUrl) : '';
    }
    const finalKey = "".concat(baseKey).concat(simplifiedSuffix);
    return finalKey;
  };
  const saveToStorage = (key, value) => {
    localStorage.setItem(getStorageKey(key), JSON.stringify(value));
  };
  const loadFromStorage = key => {
    return localStorage.getItem(getStorageKey(key));
  };

  // Fetch configuration from CDN with fallback to local file
  (0, _react.useEffect)(() => {
    const fetchConfig = async () => {
      try {
        if (configUrl) {
          const timestamp = Date.now(); // Generate a unique timestamp
          const response = await fetch(configUrl + "?timestamp=" + timestamp);
          if (!response.ok) {
            throw new Error('Failed to fetch remote config');
          }
          const data = await response.json();
          if (Object.keys(data).length === 0) {
            throw new Error('Empty remote config');
          }
          setConfig(data);
          if (data.preferences) {
            setPreferences(data.preferences);
          }
        } else {
          throw new Error('No config URL provided');
        }
      } catch (error) {
        console.warn('Falling back to local configuration:', error.message);
        try {
          // Use the imported default configuration
          setConfig(_cookieSettings.default);
          if (_cookieSettings.default.preferences) {
            setPreferences(_cookieSettings.default.preferences);
          }
        } catch (localError) {
          console.error('Error loading local configuration:', localError);
          // If both remote and local configs fail, you might want to set some minimal default config
          setConfig(null);
        }
      }
    };
    fetchConfig();
  }, [configUrl]);
  (0, _react.useEffect)(() => {
    const savedPreferences = loadFromStorage('cookiePreferences');
    const consentGiven = loadFromStorage('cookieConsentGiven');
    if (savedPreferences) {
      setPreferences(JSON.parse(savedPreferences));
    }
    if (consentGiven) {
      setHasConsented(true);
    }
  }, []);
  const handleSavePreferences = () => {
    setLoading(true);
    saveToStorage('cookiePreferences', preferences);
    saveToStorage('cookieConsentGiven', true);

    // Dispatch custom event to trigger analytics initialization
    const event = new CustomEvent('cookiePreferencesChanged');
    window.dispatchEvent(event);
    setHasConsented(true);
    setLoading(false);
    setShowModal(false);
  };
  const toggleSection = sectionId => {
    if (expandedSection === sectionId) {
      setExpandedSection(null);
    } else {
      setExpandedSection(sectionId);
    }
  };

  // If no config is available at all, show nothing
  if (!config) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, analytics && /*#__PURE__*/_react.default.createElement(_AnalyticsWrapper.default, {
    analytics: analytics
  }), !hasConsented && /*#__PURE__*/_react.default.createElement("div", {
    className: "position-fixed bottom-0 start-0 w-100 bg-white border-top py-3",
    style: {
      zIndex: 1050
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container position-relative"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "link",
    className: "position-absolute d-lg-none",
    onClick: () => setHasConsented(true),
    style: {
      fontSize: '22px',
      textDecoration: 'none',
      padding: '0 6px',
      top: '-10px',
      right: '15px',
      color: '#000'
    }
  }, "\xD7"), /*#__PURE__*/_react.default.createElement("div", {
    className: "row flex-column flex-md-row align-items-md-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-12 col-lg-8 mb-3 mb-lg-0 cookieFont pad-right"
  }, (0, _htmlReactParser.default)(config.cookieSetting.mainPageDisclaimer), " ", privacyPolicyLink ? /*#__PURE__*/_react.default.createElement("a", {
    href: privacyPolicyLink,
    target: "_blank",
    rel: "noreferrer noopenner"
  }, (0, _htmlReactParser.default)(config.cookieSetting.mainPagePrivacyPolicyText)) : "Click on the different options below to manage your cookie preferences."), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-12 col-lg-4"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex justify-content-lg-end align-items-center cookieSettingBtn gap-2"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "outline-primary",
    size: "sm",
    onClick: () => setShowModal(true),
    style: {
      border: '1px solid #0d6efd',
      borderRadius: '4px',
      padding: '6px 12px',
      fontSize: '14px',
      whiteSpace: 'nowrap'
    }
  }, (0, _htmlReactParser.default)(config.cookieSetting.buttonNames.cookieSetting)), /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "primary",
    size: "sm",
    onClick: handleSavePreferences,
    style: {
      borderRadius: '4px',
      padding: '6px 12px',
      fontSize: '14px',
      whiteSpace: 'nowrap'
    }
  }, (0, _htmlReactParser.default)(config.cookieSetting.buttonNames.acceptAllCookies)), /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "link",
    className: "d-none d-lg-block",
    onClick: () => setHasConsented(true),
    style: {
      fontSize: '30px',
      textDecoration: 'none',
      padding: '0 6px',
      color: '#000'
    }
  }, "\xD7")))))), /*#__PURE__*/_react.default.createElement(_Modal.default, {
    show: showModal,
    onHide: () => setShowModal(false),
    size: "lg",
    id: "cookieSettingModal"
  }, /*#__PURE__*/_react.default.createElement(_Modal.default.Header, {
    className: "border-bottom-0 pb-0",
    closeButton: true
  }), /*#__PURE__*/_react.default.createElement(_Modal.default.Body, {
    className: "pt-0"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "w-100"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "mb-3"
  }, config.cookieSetting.modalHeading), config.cookieSetting.modalDisclaimers.map((disclaimer, index) => /*#__PURE__*/_react.default.createElement("p", {
    key: index,
    className: "text-muted cookieFont",
    style: {
      fontSize: '0.9rem'
    }
  }, (0, _htmlReactParser.default)(disclaimer))), privacyPolicyLink && /*#__PURE__*/_react.default.createElement("p", {
    className: "mb-3 cookieFont",
    style: {
      fontSize: '0.9rem'
    }
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: privacyPolicyLink,
    target: "_blank",
    rel: "noreferrer noopenner"
  }, (0, _htmlReactParser.default)(config.cookieSetting.modalPrivacyPolicyText))), /*#__PURE__*/_react.default.createElement("h5", {
    className: "mb-4"
  }, config.cookieSetting.consentPreferencesHeading)), /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex flex-column"
  }, config.cookieTypes.map(cookieType => /*#__PURE__*/_react.default.createElement("div", {
    key: cookieType.id,
    className: "border-bottom"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "py-3 d-flex justify-content-between align-items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: cookieType.id === 'necessary' ? {
      fontWeight: 'bold'
    } : {}
  }, cookieType.label), /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex align-items-center gap-2"
  }, cookieType.id === 'necessary' ? /*#__PURE__*/_react.default.createElement("span", {
    className: "text-primary",
    style: {
      fontSize: '0.9rem',
      fontWeight: 'bold',
      whiteSpace: 'nowrap'
    }
  }, "Always Active") : /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "me-2 d-none d-md-inline",
    style: {
      fontSize: '0.9rem'
    }
  }, preferences[cookieType.id] ? 'Active' : 'Inactive'), /*#__PURE__*/_react.default.createElement(_Form.default.Check, {
    type: "switch",
    checked: preferences[cookieType.id],
    onChange: e => setPreferences(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [cookieType.id]: e.target.checked
    })),
    className: "custom-switch"
  })), /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "link",
    onClick: () => toggleSection(cookieType.id),
    className: "text-dark text-decoration-none p-0 ms-2",
    "aria-expanded": expandedSection === cookieType.id,
    style: {
      fontSize: '1.2rem',
      lineHeight: 1
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      display: 'inline-block',
      width: '12px',
      textAlign: 'center',
      transform: expandedSection === cookieType.id ? 'rotate(90deg)' : 'none',
      transition: 'transform 0.2s'
    }
  }, "\u203A")))), /*#__PURE__*/_react.default.createElement(_Collapse.default, {
    in: expandedSection === cookieType.id
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pb-3"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "text-muted mb-0",
    style: {
      fontSize: '0.9rem'
    }
  }, cookieType.description))))))), /*#__PURE__*/_react.default.createElement(_Modal.default.Footer, {
    className: "border-top-0"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: handleSavePreferences,
    className: "w-100",
    style: {
      backgroundColor: '#0066b2',
      border: 'none',
      padding: '10px',
      borderRadius: '4px'
    }
  }, (0, _htmlReactParser.default)(config.cookieSetting.buttonNames.saveChoices), loading && /*#__PURE__*/_react.default.createElement("span", null, " ", /*#__PURE__*/_react.default.createElement(_Spinner.default, {
    className: "saveChoiceSpinner"
  }))))));
};
var _default = exports.default = CookieSettings;